<template>
  <div class="section">
    <div class="title-box" v-if="title">
      <div class="title-bg"><span></span></div>
      <div class="title">
        <div class="title-text MF_1">
        <img class="star-a" src="@/assets/images/star-a.svg" alt="star" srcset=""> 
        {{ title }}
        <img class="star-b" src="@/assets/images/star-a.svg" alt="star" srcset="">
        </div>
      </div>
    </div>
    <div class="content">
      <div class="bot-bg"></div>
      <div id="partner">
        <Swiper
          :modules="[Pagination]"
          :pagination="true"
          class="partner-swiper"
        >
          <SwiperSlide v-for="(page, pageIdx) in pagedPartners" :key="pageIdx">
            <div class="partner-page">
              <div class="partner-row">
                <div class="partner-item" v-for="item in page" :key="item.user_id" @click="goToUserProfile(item)">
                  <div class="partner-avatar">
                    <img v-if="item.avatar" :src="item.avatar" :alt="item.username" />
                    <!-- <img src="https://jihuanshe-imagex.jihuanshe.com/pkm/card_versions/CS4bC-085_sc.png" :alt="item.username" /> -->
                  </div>
                  <div class="partner-username CH_4_Bold ells1">{{ item.username }}</div>
                  <div class="partner-remark CH_7_Regular ells2">{{ item.remark }}</div>
                  <div class="partner-following" @click.stop>
                    <div class="btn_sm" 
                         :class="item.following ? 'grey_btn' : 'primary_btn'"
                         @click="handleFollow(item)">
                      <span class="CH_7_Bold" style="position: relative; z-index: 9;">{{ item.following ? $t('common.alreadyFollow') : $t('common.follow') }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>

    <BaseLoading v-if="loading" background="rgba(255,255,255,0.2)"/>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { followUser, unfollowUser } from '@/api/landing';
import BaseLoading from '@components/BaseLoading.vue';
import { checkLoginAndGo } from '@/utils/token';
import { track } from '@/utils/tracking';
declare const jhsapp: any;

interface PartnerItem {
  user_id: string;
  avatar: string;
  username: string;
  following: boolean;
  remark: string;
  link: string;
}


const props = defineProps<{
  partnerList: PartnerItem[];
  title: string;
  module_ID: string;
}>();

const loading = ref(false);


// 分页逻辑：每页最多3个，最多展示12个
const pagedPartners = computed(() => {
  // 最多展示12个
  const list = props.partnerList.slice(0, 12);
  const pages: PartnerItem[][] = [];
  for (let i = 0; i < list.length; i += 3) {
    pages.push(list.slice(i, i + 3));
  }

  return pages;
});

// 跳转到用户个人主页
const goToUserProfile = (item: PartnerItem) => {
  console.log(item, '当前是partner');
  track('H5Landing_module_operation', {
    operation: 'click_on_partner_users',
  });
  track('lst_H5Landing_module_partner', {
    module_ID: props.module_ID,
    module_type: 'partner_users',
    id: item.user_id,
    name: item.username,
  });

  checkLoginAndGo(()=>{
    try {
      if (item.link) {
        jhsapp.router(item.link);
      } else  {
        jhsapp.router(`https://www.jihuanshe.com/app/user?userId=${item.user_id}`);
      }
    } catch (error) {
      console.error('跳转失败:', error);
    }
  })
};

// 处理关注/取消关注
const handleFollow = (item: PartnerItem) => {
  checkLoginAndGo( async ()=>{
    loading.value = true;
    try {
      if (item.following) {
      await unfollowUser({ following_user_id: Number(item.user_id) });
    } else {
      await followUser({ following_user_id: Number(item.user_id) });
    }
    item.following = !item.following;
    loading.value = false;
  } catch (error) {
    console.error('关注操作失败:', error);
      loading.value = false;
    }
  })
};
</script>

<style lang="scss" scoped>
@import '@/styles/section.scss';

.section{
  .content{
    padding-left: 0;
    padding-right: 0;
  }
}

#partner {
  width: 100%;

  .partner-swiper {
    width: 100%;
    min-height: 120px;
  }

  :deep(.swiper-pagination){
    position: static;
    margin-top: var(--gap-6);
  }

  :deep(.swiper-pagination-bullet){
    background: var(--container-surface-gray-alpha-subtler);
  }

  :deep(.swiper-pagination-bullet-active){
    background: var(--container-surface-dark);
  }

  .partner-page {
    padding: 0 var(--padding-8);
  }
  
  .partner-row{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    justify-content: space-between;
    gap: var(--gap-6);
    flex-wrap: wrap;
  }
  
  .partner-item {
    cursor: pointer;
    display: flex;
    // width: 110px;
    padding: var(--padding-6);
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: var(--gap-3);
    border-radius: var(--corner-6, 8px);
    background: var(--container-surface-white);
    box-shadow: 0px var(--container-effects-thickness-3) var(--container-effects-thickness-6) 0px var(--container-effects-color-gray-subtle);
  }
  .partner-avatar {
    display: flex;
    // padding: 2px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    width: 38px;
    height: 38px;
    background: #eee;
    margin: auto;
    border-radius: 50%;
    overflow: hidden;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .partner-username {
    max-width: 94px;
    word-break: break-all;
  }
  .partner-remark {
    color: var(--on-container-text-secondary);
    text-align: center;
    height: 32px;
  }

  .partner-following {
    width: 100%;
    .btn_sm{
      width: 100%;
    }
  }
}
</style> 